import { initializeApp } from "firebase/app";
import Cookies from 'js-cookie';
import { getAuth } from "firebase/auth";
import { getAnalytics } from 'firebase/analytics';

const url = Cookies.get('url');
const apiUrl = `https://${url}`;

// local
// const firebaseConfig = {
  // webGA
  //   apiKey: "AIzaSyChloLUkzafJZlQ5BdcJvvfEPvoFHldZ0o",
  // authDomain: "web-ga-c5a77.firebaseapp.com",
  // projectId: "web-ga-c5a77",
  // storageBucket: "web-ga-c5a77.firebasestorage.app",
  // messagingSenderId: "344133205795",
  // appId: "1:344133205795:web:f149630a7e43f31a771696",
  // measurementId: "G-RDW0VV4HD4"

  //React GA
  // apiKey: "AIzaSyAdsGGBh0V4-mKACEXW9CqPVQkckEBbFFs",
  // authDomain: "analytics-f2b1e.firebaseapp.com",
  // databaseURL: "https://analytics-f2b1e-default-rtdb.firebaseio.com",
  // projectId: "analytics-f2b1e",
  // storageBucket: "analytics-f2b1e.firebasestorage.app",
  // messagingSenderId: "646913850653",
  // appId: "1:646913850653:web:8422beaa5bd1af1c12f5f4",
  // measurementId: "G-9G2L8WR3D4"

// };

// aarya
const firebaseConfig = {
    apiKey: "AIzaSyBV_a5ahfm0MCphqDquM92yN-_17Bm0rGE",
    authDomain: "aarya-ott.firebaseapp.com",
    projectId: "aarya-ott",
    storageBucket: "aarya-ott.appspot.com",
    messagingSenderId: "153686127657",
    appId: "1:153686127657:web:1400ca225b016e4d639838",
    measurementId: "G-Z3YKE7VKK0"
};

// mahua
const mahua = {
    apiKey: "AIzaSyDyugNhMh9OLugoGGdwEWgdSCZ_RS7EIO4",
    authDomain: "mitwatv-3c8bf.firebaseapp.com",
    projectId: "mitwatv-3c8bf",
    storageBucket: "mitwatv-3c8bf.appspot.com",
    messagingSenderId: "663533434843",
    appId: "1:663533434843:web:c6ae9531d361de38fe99fe",
    measurementId: "G-8V44NX4CJH"
};

// const app = initializeApp(firebaseConfig);
const app = (apiUrl === "https://mahuaplay.ottsnap.in" ? initializeApp(mahua) : initializeApp(firebaseConfig));
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;